import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {MissionIssueDto, MissionIssuePreviewDto, SubmitMissionIssueDto} from "@server-models";
import {SharedIssueApiService} from "@shared/components/issues/services/shared-issue-api.service";
import {IIssueService} from "@shared/components/issues/interfaces/issue-service.interface";

@Injectable({
  providedIn: 'root',
})
export class LinkIssueMissionApiService extends SharedIssueApiService implements IIssueService {

  getIssuePreview(templateId: number): Observable<MissionIssuePreviewDto> {
    return super.get<MissionIssuePreviewDto>(`/tech/v2/issue/mission/template/${ templateId }/preview`, undefined);
  }

  getIssue(issueId: number): Observable<MissionIssueDto> {
    return super.get<MissionIssueDto>(`/tech/v2/issue/mission/${ issueId }/recent`);
  }

  sendIssueTemplatePreviewById(templateId: number, issue: SubmitMissionIssueDto): Observable<void> {
    return super.post<void>(`/tech/v2/issue/mission/template/${ templateId }/submitIssue`, undefined, issue)
  }
}
